import React, { useState, useEffect } from "react";
import { ReactComponent as ScrollIcon } from "src/assets/static/images/scrollIcon.svg";

const ScrollToTop = () => {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        // Add a scroll event listener to update the state
        const handleScroll = () => {
            const isTop = window.scrollY <= 500;
            setShowButton(!isTop);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        // Scroll to the top of the page
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            {showButton && (
                <ScrollIcon className="scroll-to-top-button" onClick={scrollToTop} />
            )}
        </>
    );
};

export default ScrollToTop;
